import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { PlacementsWithoutOpeningsHttpService } from './placements-without-opening-http.service';
import { PlacementsWithoutOpeningsActions } from './placements-without-openings.store';

@Injectable({
  providedIn: 'root',
})
export class PlacementsWithoutOpeningsEffects {
  public effects = createEffectFactory(PlacementsWithoutOpeningsActions, this.actions$);

  public fetchOne = this.effects(PlacementsWithoutOpeningsActions.fetchOne, ({ payload }) =>
    this.http.fetch$(payload.jobId).pipe(
      map(response => ({
        data: response,
      })),
    ),
  );

  constructor(
    private actions$: Actions,
    private http: PlacementsWithoutOpeningsHttpService,
  ) {}
}
